// Vendor modules
import "@uirouter/angularjs";
import 'angular-ui-bootstrap';
import './sn-webhooks';

import SNLoginComponent from './sn-login/sn-login.component';

const DEPENDENCIES = [
    'ui.router',
    'record-utilities',
    'ui.bootstrap',
    'ais.sn-webhooks'
  ];
angular.module('providers.servicenow', DEPENDENCIES)
    .component('snLogin', SNLoginComponent);





